import { BaseApi } from '@/main/baseApi';

import { API_ND_AREA, NAME } from './constants';

export const apiProvider = new BaseApi(API_ND_AREA, NAME);
